

const progressList = document.querySelector('.custom-progress-list');

const isVisibleProgress = () => {
  console.log("visible");
  const windowHeight = window.innerHeight;
   const currentTragetOffsetY = progressList.offsetTop - window.pageYOffset;
   if (currentTragetOffsetY <= windowHeight) {
    const progressBarList = document.querySelectorAll(".progress-bar");
    for(let i = 0; i < progressBarList.length; i++) {
      if(progressBarList[i].offsetWidth == 0) {
        increaseProgress(progressBarList[i]);
      }

    }
   } else {
   }
      
};
window.addEventListener('scroll', isVisibleProgress);
window.addEventListener('resize', isVisibleProgress);

function increaseProgress(elem) {
  console.log(elem.offsetWidth );
  let currentNum = 0;
  let targetNum = elem.dataset.value;
  console.log(targetNum );
  let id = setInterval(frame, 10);
  function frame() {
    console.log(currentNum);
    if (currentNum >= targetNum) {
      clearInterval(id);
    } else {
      currentNum++; 
      elem.querySelector('.progress-value').innerHTML = currentNum;
      elem.style.width = `${currentNum}%`; 
    }
  }
}

document.addEventListener("DOMContentLoaded", isVisibleProgress);